/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { BillingOrgSummaryBooleanResponse } from '../model/billingOrgSummaryBooleanResponse';
// @ts-ignore
import { BillingRawUsagePaginatedResponse } from '../model/billingRawUsagePaginatedResponse';
// @ts-ignore
import { BillingRawUsagePatchSpec } from '../model/billingRawUsagePatchSpec';
// @ts-ignore
import { BillingRawUsagePostSpec } from '../model/billingRawUsagePostSpec';
// @ts-ignore
import { BillingRawUsageResponse } from '../model/billingRawUsageResponse';
// @ts-ignore
import { DailyOrgSummaryBulkResponse } from '../model/dailyOrgSummaryBulkResponse';
// @ts-ignore
import { DailyOrgSummaryPaginatedResponse } from '../model/dailyOrgSummaryPaginatedResponse';
// @ts-ignore
import { DailyOrgSummaryPatchSpec } from '../model/dailyOrgSummaryPatchSpec';
// @ts-ignore
import { DailyOrgSummaryPostSpec } from '../model/dailyOrgSummaryPostSpec';
// @ts-ignore
import { DailyOrgSummaryUsageResponse } from '../model/dailyOrgSummaryUsageResponse';
// @ts-ignore
import { DisconnectedEntityLicenseOfferBulkResponse } from '../model/disconnectedEntityLicenseOfferBulkResponse';
// @ts-ignore
import { DisconnectedLicenseHasCapacityResponse } from '../model/disconnectedLicenseHasCapacityResponse';
// @ts-ignore
import { DisconnectedUsageBulkResponse } from '../model/disconnectedUsageBulkResponse';
// @ts-ignore
import { DisconnectedUsagePaginatedResponse } from '../model/disconnectedUsagePaginatedResponse';
// @ts-ignore
import { DisconnectedUsagePatchSpec } from '../model/disconnectedUsagePatchSpec';
// @ts-ignore
import { DisconnectedUsagePostSpec } from '../model/disconnectedUsagePostSpec';
// @ts-ignore
import { DisconnectedUsageResponse } from '../model/disconnectedUsageResponse';
// @ts-ignore
import { RecordDisconnectedUsagePostSpec } from '../model/recordDisconnectedUsagePostSpec';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class BillingUsageOperatorService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Delete all org summary data
     * truncate org summary data
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteBillingAllOrgSummary(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<BillingOrgSummaryBooleanResponse>;
    public deleteBillingAllOrgSummary(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<BillingOrgSummaryBooleanResponse>>;
    public deleteBillingAllOrgSummary(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<BillingOrgSummaryBooleanResponse>>;
    public deleteBillingAllOrgSummary(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/truncate-daily-org-summary`;
        return this.httpClient.request<BillingOrgSummaryBooleanResponse>('delete', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Delete billing raw usage by id
     * Delete billing raw usage by id
     * @param billingRawUsageQueryIdRequired Billing Raw Usage Primary Key
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteBillingRawUsage(billingRawUsageQueryIdRequired: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<BillingRawUsageResponse>;
    public deleteBillingRawUsage(billingRawUsageQueryIdRequired: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<BillingRawUsageResponse>>;
    public deleteBillingRawUsage(billingRawUsageQueryIdRequired: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<BillingRawUsageResponse>>;
    public deleteBillingRawUsage(billingRawUsageQueryIdRequired: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (billingRawUsageQueryIdRequired === null || billingRawUsageQueryIdRequired === undefined) {
            throw new Error('Required parameter billingRawUsageQueryIdRequired was null or undefined when calling deleteBillingRawUsage.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>billingRawUsageQueryIdRequired, 'billing-raw-usage-query-id-required');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/raw-usage`;
        return this.httpClient.request<BillingRawUsageResponse>('delete', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Delete disconnected usage by id
     * Delete disconnected usage by id
     * @param billingDisconnectedUsageQueryIdRequired Billing Disconnected Usage Primary Key
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteDisconnectedUsageOperator(billingDisconnectedUsageQueryIdRequired: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<DisconnectedUsageResponse>;
    public deleteDisconnectedUsageOperator(billingDisconnectedUsageQueryIdRequired: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<DisconnectedUsageResponse>>;
    public deleteDisconnectedUsageOperator(billingDisconnectedUsageQueryIdRequired: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<DisconnectedUsageResponse>>;
    public deleteDisconnectedUsageOperator(billingDisconnectedUsageQueryIdRequired: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (billingDisconnectedUsageQueryIdRequired === null || billingDisconnectedUsageQueryIdRequired === undefined) {
            throw new Error('Required parameter billingDisconnectedUsageQueryIdRequired was null or undefined when calling deleteDisconnectedUsageOperator.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>billingDisconnectedUsageQueryIdRequired, 'billing-disconnected-usage-query-id-required');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/disconnected-usage`;
        return this.httpClient.request<DisconnectedUsageResponse>('delete', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Delete daily org usage summary data by org_id
     * Delete daily org usage summary data by org_id
     * @param orgId organization identifier
     * @param usageDate Date for usage summary in YYYY-MM-DD
     * @param serviceType Service Type
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteOrgDailySummary(orgId: string, usageDate?: string, serviceType?: 'VCDR' | 'VMCFS' | 'VMUA', observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<DailyOrgSummaryBulkResponse>;
    public deleteOrgDailySummary(orgId: string, usageDate?: string, serviceType?: 'VCDR' | 'VMCFS' | 'VMUA', observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<DailyOrgSummaryBulkResponse>>;
    public deleteOrgDailySummary(orgId: string, usageDate?: string, serviceType?: 'VCDR' | 'VMCFS' | 'VMUA', observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<DailyOrgSummaryBulkResponse>>;
    public deleteOrgDailySummary(orgId: string, usageDate?: string, serviceType?: 'VCDR' | 'VMCFS' | 'VMUA', observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (orgId === null || orgId === undefined) {
            throw new Error('Required parameter orgId was null or undefined when calling deleteOrgDailySummary.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>orgId, 'org-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>usageDate, 'usage-date');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>serviceType, 'service-type');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/daily-org-summary`;
        return this.httpClient.request<DailyOrgSummaryBulkResponse>('delete', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get all billing raw usage by filters
     * Get all billing raw usage by filter
     * @param sortByOrder Sort the properties by this order
     * @param sortBy Sort the billing raw usage by this column
     * @param billingRawUsageOptionalQueryId Billing Raw Usage Primary Key In Optional Filter
     * @param orgId organization identifier in optional filter
     * @param billingEntityOptionalQueryId Billing Entity Primary Id In Optional Filter
     * @param billingIsExtrapolatedQueryOptional Billing isExtrapolated In Optional Filter
     * @param billingRawUsageStateQueryOptional Billing Raw Usage State In Optional Filter
     * @param startTime Time at which query starts
     * @param endTime Time at which query ends
     * @param pageNo Page Number (It starts from 0)
     * @param pageSize Page Size
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getBillingRawUsage(sortByOrder: 'ASC' | 'DESC', sortBy: 'id' | 'entityId' | 'isExtrapolated' | 'state' | 'usageTs' | 'createdTs' | 'updatedTs', billingRawUsageOptionalQueryId?: number, orgId?: string, billingEntityOptionalQueryId?: number, billingIsExtrapolatedQueryOptional?: boolean, billingRawUsageStateQueryOptional?: 'DOWNLOADED' | 'PROCESSED' | 'SKIPPED' | 'UPLOADED' | 'FAILED' | 'ERROR', startTime?: string, endTime?: string, pageNo?: number, pageSize?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<BillingRawUsagePaginatedResponse>;
    public getBillingRawUsage(sortByOrder: 'ASC' | 'DESC', sortBy: 'id' | 'entityId' | 'isExtrapolated' | 'state' | 'usageTs' | 'createdTs' | 'updatedTs', billingRawUsageOptionalQueryId?: number, orgId?: string, billingEntityOptionalQueryId?: number, billingIsExtrapolatedQueryOptional?: boolean, billingRawUsageStateQueryOptional?: 'DOWNLOADED' | 'PROCESSED' | 'SKIPPED' | 'UPLOADED' | 'FAILED' | 'ERROR', startTime?: string, endTime?: string, pageNo?: number, pageSize?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<BillingRawUsagePaginatedResponse>>;
    public getBillingRawUsage(sortByOrder: 'ASC' | 'DESC', sortBy: 'id' | 'entityId' | 'isExtrapolated' | 'state' | 'usageTs' | 'createdTs' | 'updatedTs', billingRawUsageOptionalQueryId?: number, orgId?: string, billingEntityOptionalQueryId?: number, billingIsExtrapolatedQueryOptional?: boolean, billingRawUsageStateQueryOptional?: 'DOWNLOADED' | 'PROCESSED' | 'SKIPPED' | 'UPLOADED' | 'FAILED' | 'ERROR', startTime?: string, endTime?: string, pageNo?: number, pageSize?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<BillingRawUsagePaginatedResponse>>;
    public getBillingRawUsage(sortByOrder: 'ASC' | 'DESC', sortBy: 'id' | 'entityId' | 'isExtrapolated' | 'state' | 'usageTs' | 'createdTs' | 'updatedTs', billingRawUsageOptionalQueryId?: number, orgId?: string, billingEntityOptionalQueryId?: number, billingIsExtrapolatedQueryOptional?: boolean, billingRawUsageStateQueryOptional?: 'DOWNLOADED' | 'PROCESSED' | 'SKIPPED' | 'UPLOADED' | 'FAILED' | 'ERROR', startTime?: string, endTime?: string, pageNo?: number, pageSize?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (sortByOrder === null || sortByOrder === undefined) {
            throw new Error('Required parameter sortByOrder was null or undefined when calling getBillingRawUsage.');
        }
        if (sortBy === null || sortBy === undefined) {
            throw new Error('Required parameter sortBy was null or undefined when calling getBillingRawUsage.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>sortByOrder, 'sort-by-order');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>sortBy, 'sort-by');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>billingRawUsageOptionalQueryId, 'billing-raw-usage-optional-query-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>orgId, 'org-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>billingEntityOptionalQueryId, 'billing-entity-optional-query-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>billingIsExtrapolatedQueryOptional, 'billing-is-extrapolated-query-optional');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>billingRawUsageStateQueryOptional, 'billing-raw-usage-state-query-optional');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>startTime, 'start-time');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>endTime, 'end-time');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageNo, 'page-no');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageSize, 'page-size');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/raw-usage`;
        return this.httpClient.request<BillingRawUsagePaginatedResponse>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get all disconnected usages by filters
     * Get all disconnected usages by filter
     * @param sortByOrder Sort the properties by this order
     * @param sortBy Sort the disconnected usage by this column
     * @param orgId organization identifier in optional filter
     * @param entityId Entity UUID
     * @param quantity Quantity In Optional Filter
     * @param state Disconnected usage state
     * @param vlsrPersona VLSR Persona
     * @param startTime Time at which query starts
     * @param endTime Time at which query ends
     * @param pageNo Page Number (It starts from 0)
     * @param pageSize Page Size
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getDisconnectedUsageOperator(sortByOrder: 'ASC' | 'DESC', sortBy: 'id' | 'orgId' | 'entityUuid' | 'quantity' | 'state' | 'createdTs' | 'updatedTs' | 'expiryTs', orgId?: string, entityId?: string, quantity?: number, state?: 'CREATED' | 'ACTIVATED' | 'EXPIRED', vlsrPersona?: 'VLSR' | 'VLSR_MTDR', startTime?: string, endTime?: string, pageNo?: number, pageSize?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<DisconnectedUsagePaginatedResponse>;
    public getDisconnectedUsageOperator(sortByOrder: 'ASC' | 'DESC', sortBy: 'id' | 'orgId' | 'entityUuid' | 'quantity' | 'state' | 'createdTs' | 'updatedTs' | 'expiryTs', orgId?: string, entityId?: string, quantity?: number, state?: 'CREATED' | 'ACTIVATED' | 'EXPIRED', vlsrPersona?: 'VLSR' | 'VLSR_MTDR', startTime?: string, endTime?: string, pageNo?: number, pageSize?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<DisconnectedUsagePaginatedResponse>>;
    public getDisconnectedUsageOperator(sortByOrder: 'ASC' | 'DESC', sortBy: 'id' | 'orgId' | 'entityUuid' | 'quantity' | 'state' | 'createdTs' | 'updatedTs' | 'expiryTs', orgId?: string, entityId?: string, quantity?: number, state?: 'CREATED' | 'ACTIVATED' | 'EXPIRED', vlsrPersona?: 'VLSR' | 'VLSR_MTDR', startTime?: string, endTime?: string, pageNo?: number, pageSize?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<DisconnectedUsagePaginatedResponse>>;
    public getDisconnectedUsageOperator(sortByOrder: 'ASC' | 'DESC', sortBy: 'id' | 'orgId' | 'entityUuid' | 'quantity' | 'state' | 'createdTs' | 'updatedTs' | 'expiryTs', orgId?: string, entityId?: string, quantity?: number, state?: 'CREATED' | 'ACTIVATED' | 'EXPIRED', vlsrPersona?: 'VLSR' | 'VLSR_MTDR', startTime?: string, endTime?: string, pageNo?: number, pageSize?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (sortByOrder === null || sortByOrder === undefined) {
            throw new Error('Required parameter sortByOrder was null or undefined when calling getDisconnectedUsageOperator.');
        }
        if (sortBy === null || sortBy === undefined) {
            throw new Error('Required parameter sortBy was null or undefined when calling getDisconnectedUsageOperator.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>sortByOrder, 'sort-by-order');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>sortBy, 'sort-by');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>orgId, 'org-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>entityId, 'entity-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>quantity, 'quantity');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>state, 'state');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>vlsrPersona, 'vlsr-persona');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>startTime, 'start-time');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>endTime, 'end-time');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageNo, 'page-no');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageSize, 'page-size');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/disconnected-usage`;
        return this.httpClient.request<DisconnectedUsagePaginatedResponse>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get all disconnected license offers
     * Get all disconnected license offers
     * @param orgId organization identifier
     * @param entityUuid Entity UUID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getLicenseOffers(orgId: string, entityUuid: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<DisconnectedEntityLicenseOfferBulkResponse>;
    public getLicenseOffers(orgId: string, entityUuid: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<DisconnectedEntityLicenseOfferBulkResponse>>;
    public getLicenseOffers(orgId: string, entityUuid: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<DisconnectedEntityLicenseOfferBulkResponse>>;
    public getLicenseOffers(orgId: string, entityUuid: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (orgId === null || orgId === undefined) {
            throw new Error('Required parameter orgId was null or undefined when calling getLicenseOffers.');
        }
        if (entityUuid === null || entityUuid === undefined) {
            throw new Error('Required parameter entityUuid was null or undefined when calling getLicenseOffers.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>orgId, 'org-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>entityUuid, 'entity-uuid');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/offers`;
        return this.httpClient.request<DisconnectedEntityLicenseOfferBulkResponse>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get daily org usage summary by filters
     * Get daily org usage summary by filters
     * @param sortByOrder Sort the properties by this order
     * @param sortBy Sort the daily org summary usage by this column
     * @param orgId organization identifier in optional filter
     * @param usageDate Date for usage summary in YYYY-MM-DD
     * @param startUsageDate start date for usage summary in YYYY-MM-DD
     * @param endUsageDate end date for usage summary in YYYY-MM-DD
     * @param serviceType Service Type
     * @param pageNoNullableOptional Page Number (It starts from 0)
     * @param pageSizeNullableOptional Page Size
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getOrgDailySummary(sortByOrder?: 'ASC' | 'DESC', sortBy?: 'orgId' | 'usageDate' | 'vcdsServiceType', orgId?: string, usageDate?: string, startUsageDate?: string, endUsageDate?: string, serviceType?: 'VCDR' | 'VMCFS' | 'VMUA', pageNoNullableOptional?: number, pageSizeNullableOptional?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<DailyOrgSummaryPaginatedResponse>;
    public getOrgDailySummary(sortByOrder?: 'ASC' | 'DESC', sortBy?: 'orgId' | 'usageDate' | 'vcdsServiceType', orgId?: string, usageDate?: string, startUsageDate?: string, endUsageDate?: string, serviceType?: 'VCDR' | 'VMCFS' | 'VMUA', pageNoNullableOptional?: number, pageSizeNullableOptional?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<DailyOrgSummaryPaginatedResponse>>;
    public getOrgDailySummary(sortByOrder?: 'ASC' | 'DESC', sortBy?: 'orgId' | 'usageDate' | 'vcdsServiceType', orgId?: string, usageDate?: string, startUsageDate?: string, endUsageDate?: string, serviceType?: 'VCDR' | 'VMCFS' | 'VMUA', pageNoNullableOptional?: number, pageSizeNullableOptional?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<DailyOrgSummaryPaginatedResponse>>;
    public getOrgDailySummary(sortByOrder?: 'ASC' | 'DESC', sortBy?: 'orgId' | 'usageDate' | 'vcdsServiceType', orgId?: string, usageDate?: string, startUsageDate?: string, endUsageDate?: string, serviceType?: 'VCDR' | 'VMCFS' | 'VMUA', pageNoNullableOptional?: number, pageSizeNullableOptional?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>sortByOrder, 'sort-by-order');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>sortBy, 'sort-by');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>orgId, 'org-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>usageDate, 'usage-date');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>startUsageDate, 'start-usage-date');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>endUsageDate, 'end-usage-date');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>serviceType, 'service-type');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageNoNullableOptional, 'page-no-nullable-optional');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageSizeNullableOptional, 'page-size-nullable-optional');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/daily-org-summary`;
        return this.httpClient.request<DailyOrgSummaryPaginatedResponse>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns the validity of a disconnected license offer
     * Returns the validity of a disconnected license offer
     * @param orgId organization identifier
     * @param entityUuid Entity UUID
     * @param quantityQueryParam Quantity
     * @param expiryDate Disconnected entity license expiry time.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public hasCapacity(orgId: string, entityUuid: string, quantityQueryParam: number, expiryDate: Date, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<DisconnectedLicenseHasCapacityResponse>;
    public hasCapacity(orgId: string, entityUuid: string, quantityQueryParam: number, expiryDate: Date, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<DisconnectedLicenseHasCapacityResponse>>;
    public hasCapacity(orgId: string, entityUuid: string, quantityQueryParam: number, expiryDate: Date, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<DisconnectedLicenseHasCapacityResponse>>;
    public hasCapacity(orgId: string, entityUuid: string, quantityQueryParam: number, expiryDate: Date, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (orgId === null || orgId === undefined) {
            throw new Error('Required parameter orgId was null or undefined when calling hasCapacity.');
        }
        if (entityUuid === null || entityUuid === undefined) {
            throw new Error('Required parameter entityUuid was null or undefined when calling hasCapacity.');
        }
        if (quantityQueryParam === null || quantityQueryParam === undefined) {
            throw new Error('Required parameter quantityQueryParam was null or undefined when calling hasCapacity.');
        }
        if (expiryDate === null || expiryDate === undefined) {
            throw new Error('Required parameter expiryDate was null or undefined when calling hasCapacity.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>orgId, 'org-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>entityUuid, 'entity-uuid');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>quantityQueryParam, 'quantity-query-param');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>expiryDate, 'Expiry Date');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/has-capacity`;
        return this.httpClient.request<DisconnectedLicenseHasCapacityResponse>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Patch billing raw usage by id
     * Find and patch billing raw usage by id
     * @param billingRawUsageQueryIdRequired Billing Raw Usage Primary Key
     * @param billingRawUsagePatchSpec Billing Raw Usage patch spec
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public patchBillingRawUsage(billingRawUsageQueryIdRequired: number, billingRawUsagePatchSpec: BillingRawUsagePatchSpec, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<BillingRawUsageResponse>;
    public patchBillingRawUsage(billingRawUsageQueryIdRequired: number, billingRawUsagePatchSpec: BillingRawUsagePatchSpec, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<BillingRawUsageResponse>>;
    public patchBillingRawUsage(billingRawUsageQueryIdRequired: number, billingRawUsagePatchSpec: BillingRawUsagePatchSpec, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<BillingRawUsageResponse>>;
    public patchBillingRawUsage(billingRawUsageQueryIdRequired: number, billingRawUsagePatchSpec: BillingRawUsagePatchSpec, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (billingRawUsageQueryIdRequired === null || billingRawUsageQueryIdRequired === undefined) {
            throw new Error('Required parameter billingRawUsageQueryIdRequired was null or undefined when calling patchBillingRawUsage.');
        }
        if (billingRawUsagePatchSpec === null || billingRawUsagePatchSpec === undefined) {
            throw new Error('Required parameter billingRawUsagePatchSpec was null or undefined when calling patchBillingRawUsage.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>billingRawUsageQueryIdRequired, 'billing-raw-usage-query-id-required');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/raw-usage`;
        return this.httpClient.request<BillingRawUsageResponse>('patch', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: billingRawUsagePatchSpec,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Patch disconnected usage by id
     * Find and patch disconnected usage by id
     * @param billingDisconnectedUsageQueryIdRequired Billing Disconnected Usage Primary Key
     * @param disconnectedUsagePatchSpec Disconnected usage patch spec
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public patchDisconnectedUsageOperator(billingDisconnectedUsageQueryIdRequired: number, disconnectedUsagePatchSpec: DisconnectedUsagePatchSpec, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<DisconnectedUsageResponse>;
    public patchDisconnectedUsageOperator(billingDisconnectedUsageQueryIdRequired: number, disconnectedUsagePatchSpec: DisconnectedUsagePatchSpec, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<DisconnectedUsageResponse>>;
    public patchDisconnectedUsageOperator(billingDisconnectedUsageQueryIdRequired: number, disconnectedUsagePatchSpec: DisconnectedUsagePatchSpec, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<DisconnectedUsageResponse>>;
    public patchDisconnectedUsageOperator(billingDisconnectedUsageQueryIdRequired: number, disconnectedUsagePatchSpec: DisconnectedUsagePatchSpec, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (billingDisconnectedUsageQueryIdRequired === null || billingDisconnectedUsageQueryIdRequired === undefined) {
            throw new Error('Required parameter billingDisconnectedUsageQueryIdRequired was null or undefined when calling patchDisconnectedUsageOperator.');
        }
        if (disconnectedUsagePatchSpec === null || disconnectedUsagePatchSpec === undefined) {
            throw new Error('Required parameter disconnectedUsagePatchSpec was null or undefined when calling patchDisconnectedUsageOperator.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>billingDisconnectedUsageQueryIdRequired, 'billing-disconnected-usage-query-id-required');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/disconnected-usage`;
        return this.httpClient.request<DisconnectedUsageResponse>('patch', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: disconnectedUsagePatchSpec,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Patch daily org usage summary by unique key
     * Find and patch daily org usage summary by unique key
     * @param orgId organization identifier
     * @param usageDate Date for usage summary in YYYY-MM-DD
     * @param serviceType Service Type
     * @param dailyOrgSummaryPatchSpec Daily org summary patch spec
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public patchOrgDailySummary(orgId: string, usageDate: string, serviceType: 'VCDR' | 'VMCFS' | 'VMUA', dailyOrgSummaryPatchSpec: DailyOrgSummaryPatchSpec, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<DailyOrgSummaryUsageResponse>;
    public patchOrgDailySummary(orgId: string, usageDate: string, serviceType: 'VCDR' | 'VMCFS' | 'VMUA', dailyOrgSummaryPatchSpec: DailyOrgSummaryPatchSpec, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<DailyOrgSummaryUsageResponse>>;
    public patchOrgDailySummary(orgId: string, usageDate: string, serviceType: 'VCDR' | 'VMCFS' | 'VMUA', dailyOrgSummaryPatchSpec: DailyOrgSummaryPatchSpec, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<DailyOrgSummaryUsageResponse>>;
    public patchOrgDailySummary(orgId: string, usageDate: string, serviceType: 'VCDR' | 'VMCFS' | 'VMUA', dailyOrgSummaryPatchSpec: DailyOrgSummaryPatchSpec, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (orgId === null || orgId === undefined) {
            throw new Error('Required parameter orgId was null or undefined when calling patchOrgDailySummary.');
        }
        if (usageDate === null || usageDate === undefined) {
            throw new Error('Required parameter usageDate was null or undefined when calling patchOrgDailySummary.');
        }
        if (serviceType === null || serviceType === undefined) {
            throw new Error('Required parameter serviceType was null or undefined when calling patchOrgDailySummary.');
        }
        if (dailyOrgSummaryPatchSpec === null || dailyOrgSummaryPatchSpec === undefined) {
            throw new Error('Required parameter dailyOrgSummaryPatchSpec was null or undefined when calling patchOrgDailySummary.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>orgId, 'org-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>usageDate, 'usage-date');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>serviceType, 'service-type');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/daily-org-summary`;
        return this.httpClient.request<DailyOrgSummaryUsageResponse>('patch', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: dailyOrgSummaryPatchSpec,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Create billing raw usage
     * Create new billing raw usage
     * @param billingRawUsagePostSpec Billing raw usage post spec
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public postBillingRawUsage(billingRawUsagePostSpec: BillingRawUsagePostSpec, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<BillingRawUsageResponse>;
    public postBillingRawUsage(billingRawUsagePostSpec: BillingRawUsagePostSpec, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<BillingRawUsageResponse>>;
    public postBillingRawUsage(billingRawUsagePostSpec: BillingRawUsagePostSpec, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<BillingRawUsageResponse>>;
    public postBillingRawUsage(billingRawUsagePostSpec: BillingRawUsagePostSpec, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (billingRawUsagePostSpec === null || billingRawUsagePostSpec === undefined) {
            throw new Error('Required parameter billingRawUsagePostSpec was null or undefined when calling postBillingRawUsage.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/raw-usage`;
        return this.httpClient.request<BillingRawUsageResponse>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: billingRawUsagePostSpec,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Create disconnected usage
     * Create new disconnected usage
     * @param disconnectedUsagePostSpec Disconnected usage post spec
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public postDisconnectedUsageOperator(disconnectedUsagePostSpec: Array<DisconnectedUsagePostSpec>, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<DisconnectedUsageBulkResponse>;
    public postDisconnectedUsageOperator(disconnectedUsagePostSpec: Array<DisconnectedUsagePostSpec>, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<DisconnectedUsageBulkResponse>>;
    public postDisconnectedUsageOperator(disconnectedUsagePostSpec: Array<DisconnectedUsagePostSpec>, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<DisconnectedUsageBulkResponse>>;
    public postDisconnectedUsageOperator(disconnectedUsagePostSpec: Array<DisconnectedUsagePostSpec>, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (disconnectedUsagePostSpec === null || disconnectedUsagePostSpec === undefined) {
            throw new Error('Required parameter disconnectedUsagePostSpec was null or undefined when calling postDisconnectedUsageOperator.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/disconnected-usage`;
        return this.httpClient.request<DisconnectedUsageBulkResponse>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: disconnectedUsagePostSpec,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Create daily org usage summary
     * Create new daily org usage summary
     * @param dailyOrgSummaryPostSpec Daily org summary post spec
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public postOrgDailySummary(dailyOrgSummaryPostSpec: Array<DailyOrgSummaryPostSpec>, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<DailyOrgSummaryBulkResponse>;
    public postOrgDailySummary(dailyOrgSummaryPostSpec: Array<DailyOrgSummaryPostSpec>, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<DailyOrgSummaryBulkResponse>>;
    public postOrgDailySummary(dailyOrgSummaryPostSpec: Array<DailyOrgSummaryPostSpec>, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<DailyOrgSummaryBulkResponse>>;
    public postOrgDailySummary(dailyOrgSummaryPostSpec: Array<DailyOrgSummaryPostSpec>, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (dailyOrgSummaryPostSpec === null || dailyOrgSummaryPostSpec === undefined) {
            throw new Error('Required parameter dailyOrgSummaryPostSpec was null or undefined when calling postOrgDailySummary.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/daily-org-summary`;
        return this.httpClient.request<DailyOrgSummaryBulkResponse>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: dailyOrgSummaryPostSpec,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Regenerate daily org usage summary
     * Create new daily org usage summary
     * @param orgId organization identifier
     * @param dryRun Execute the API/Workflow in dry run mode
     * @param startUsageDate start date for usage summary in YYYY-MM-DD
     * @param endUsageDate end date for usage summary in YYYY-MM-DD
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public postRegenerateDailyOrgSummaryOperator(orgId: string, dryRun: boolean, startUsageDate?: string, endUsageDate?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<DailyOrgSummaryBulkResponse>;
    public postRegenerateDailyOrgSummaryOperator(orgId: string, dryRun: boolean, startUsageDate?: string, endUsageDate?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<DailyOrgSummaryBulkResponse>>;
    public postRegenerateDailyOrgSummaryOperator(orgId: string, dryRun: boolean, startUsageDate?: string, endUsageDate?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<DailyOrgSummaryBulkResponse>>;
    public postRegenerateDailyOrgSummaryOperator(orgId: string, dryRun: boolean, startUsageDate?: string, endUsageDate?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (orgId === null || orgId === undefined) {
            throw new Error('Required parameter orgId was null or undefined when calling postRegenerateDailyOrgSummaryOperator.');
        }
        if (dryRun === null || dryRun === undefined) {
            throw new Error('Required parameter dryRun was null or undefined when calling postRegenerateDailyOrgSummaryOperator.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>orgId, 'org-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>startUsageDate, 'start-usage-date');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>endUsageDate, 'end-usage-date');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>dryRun, 'dry-run');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/regenerate-daily-org-summary`;
        return this.httpClient.request<DailyOrgSummaryBulkResponse>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Record a disconnected usage
     * Record a disconnected usage
     * @param recordDisconnectedUsagePostSpec Record disconnected usage post spec
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public recordDisconnectedUsage(recordDisconnectedUsagePostSpec: RecordDisconnectedUsagePostSpec, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public recordDisconnectedUsage(recordDisconnectedUsagePostSpec: RecordDisconnectedUsagePostSpec, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public recordDisconnectedUsage(recordDisconnectedUsagePostSpec: RecordDisconnectedUsagePostSpec, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public recordDisconnectedUsage(recordDisconnectedUsagePostSpec: RecordDisconnectedUsagePostSpec, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (recordDisconnectedUsagePostSpec === null || recordDisconnectedUsagePostSpec === undefined) {
            throw new Error('Required parameter recordDisconnectedUsagePostSpec was null or undefined when calling recordDisconnectedUsage.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/record-disconnected-usage`;
        return this.httpClient.request<any>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: recordDisconnectedUsagePostSpec,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
